const getMetaId = id => {

  if ((id).includes("gid://shopify/CheckoutLineItem/")) {
    return (id).substr(31,15);
  }

  return atob(id).replace("gid://shopify/ProductVariant/", "");
};

export default getMetaId;
